<script setup>
import { ref } from "vue";
import { Link } from "@inertiajs/vue2";

const props = defineProps({
    title: {
        type: String,
        default: "",
        required: false,
    },
    contact: {
        type: Object,
        required: true,
    },
});

// Emits

const emit = defineEmits(["reset"]);

// Reactive State

const show = ref(true);

// Methods

function handleReset() {
    show.value = false;
    emit("reset");
}
</script>

<template>
    <SoliResponsiveDialog
        v-if="show"
        :titleClasses="['pt-1']"
        :subtitle="
            contact.relation ? `${contact.relation}: ${contact.name}` : null
        "
        @reset="handleReset()"
    >
        <template #title>
            <Link :href="`/profile/${contact.id}/account`">
                {{ title ?? contact.name }}
            </Link>
        </template>
        <template #body>
            <v-divider />
            <v-card-actions class="justify-space-around mb-3">
                <v-btn
                    icon
                    :href="
                        route('conversation.search', {
                            recipients: [
                                {
                                    messagable_id: contact.id,
                                    messagable_type: 'App\\Models\\User',
                                },
                            ],
                            channel: 'chat',
                        })
                    "
                    ><v-icon color="dark">chat_bubble_outline</v-icon>
                    <small class="mt-1 panel-text" style="text-transform: none"
                        >Message</small
                    >
                </v-btn>
                <v-btn
                    :disabled="!contact.phone"
                    icon
                    :href="'tel:' + contact.phone"
                    ><v-icon color="dark">phone</v-icon>
                    <small class="mt-1 panel-text" style="text-transform: none"
                        >Call</small
                    > </v-btn
                ><v-btn
                    :disabled="!contact.phone"
                    icon
                    :href="'sms:' + contact.phone"
                    ><v-icon color="dark">sms</v-icon>
                    <small class="mt-1 panel-text" style="text-transform: none"
                        >Text</small
                    > </v-btn
                ><v-btn icon :href="'mailto:' + contact.email"
                    ><v-icon color="dark">email</v-icon>
                    <small class="mt-1 panel-text" style="text-transform: none"
                        >Email</small
                    >
                </v-btn></v-card-actions
            >
            <v-divider />
            <v-list dense>
                <v-list-item
                    ><v-icon class="mr-3" color="dark">phone</v-icon
                    >{{ contact.phone }}</v-list-item
                >
                <v-list-item
                    ><v-icon class="mr-3" color="dark">email</v-icon
                    >{{ contact.email }}</v-list-item
                >
            </v-list>
        </template>
    </SoliResponsiveDialog>
</template>
